/**
 * @flow
 * @relayHash 56cd7156201cac8c12239a067cb59bc1
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type SolicitationQuickView_solicitation$ref = any;
type SolicitationsList_solicitations$ref = any;
type SolicitationsList_stateTypes$ref = any;
export type SolicitationsPageQueryVariables = {|
  first?: ?number,
  orderBy?: ?string,
  after?: ?string,
  replyByFrom?: ?any,
  replyByTo?: ?any,
  id: string,
  state?: ?string,
  subject?: ?string,
  staffCoordinator?: ?string,
  includeClosed?: ?boolean,
|};
export type SolicitationsPageQueryResponse = {|
  +__type: ?{|
    +$fragmentRefs: SolicitationsList_stateTypes$ref
  |},
  +$fragmentRefs: SolicitationsList_solicitations$ref & SolicitationQuickView_solicitation$ref,
|};
export type SolicitationsPageQuery = {|
  variables: SolicitationsPageQueryVariables,
  response: SolicitationsPageQueryResponse,
|};
*/

/*
query SolicitationsPageQuery(
  $first: Int
  $orderBy: String
  $after: String
  $replyByFrom: Date
  $replyByTo: Date
  $state: String
  $subject: String
  $staffCoordinator: ID
  $includeClosed: Boolean
) {
  ...SolicitationsList_solicitations
  __type(name: "SolicitationState") {
    ...SolicitationsList_stateTypes
  }
  ...SolicitationQuickView_solicitation
}

fragment SolicitationsList_solicitations on Query {
  allSolicitations(first: $first, orderBy: $orderBy, after: $after, replyByFrom: $replyByFrom, replyByTo: $replyByTo, state: $state, subject: $subject, staffCoordinator: $staffCoordinator, includeClosed: $includeClosed) {
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
    edgeCount
    edges {
      node {
        id
        created
        subject
        replyByDate
        staffCoordinator {
          fullName
          representativeImageUrl
          user {
            id
          }
          id
        }
        releases {
          name
          id
          product {
            title
            id
          }
        }
        state
        numberOfContractors
        numberOfDeliverables
        totalDeliverableAmount
        solicitationId
        numberOfAllocatedDeliverables
        numberOfAllocatedContractedDeliverables
      }
    }
  }
}

fragment SolicitationsList_stateTypes on __Type {
  enumValues {
    name
    description
  }
}

fragment SolicitationQuickView_solicitation on Query {
  solicitation(id: "") {
    subject
    message
    ...SolicitationQuickViewContractorList_solicitation
    id
  }
}

fragment SolicitationQuickViewContractorList_solicitation on SolicitationNode {
  id
  state
  contractors(orderBy: "newest_comment") {
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
    edgeCount
    edges {
      node {
        id
        fullName
        representativeImageUrl
        numberOfCommentsInSolicitation
        freelancer {
          user {
            userId
            id
          }
          id
        }
      }
    }
  }
}
*/

const node /*: ConcreteRequest*/ = (function () {
  var v0 = [
      {
        kind: 'LocalArgument',
        name: 'first',
        type: 'Int',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'orderBy',
        type: 'String',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'after',
        type: 'String',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'replyByFrom',
        type: 'Date',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'replyByTo',
        type: 'Date',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'id',
        type: 'ID!',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'state',
        type: 'String',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'subject',
        type: 'String',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'staffCoordinator',
        type: 'ID',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'includeClosed',
        type: 'Boolean',
        defaultValue: null
      }
    ],
    v1 = [
      {
        kind: 'Literal',
        name: 'name',
        value: 'SolicitationState'
      }
    ],
    v2 = {
      kind: 'LinkedField',
      alias: null,
      name: 'pageInfo',
      storageKey: null,
      args: null,
      concreteType: 'PageInfo',
      plural: false,
      selections: [
        {
          kind: 'ScalarField',
          alias: null,
          name: 'hasNextPage',
          args: null,
          storageKey: null
        },
        {
          kind: 'ScalarField',
          alias: null,
          name: 'endCursor',
          args: null,
          storageKey: null
        }
      ]
    },
    v3 = {
      kind: 'ScalarField',
      alias: null,
      name: 'totalCount',
      args: null,
      storageKey: null
    },
    v4 = {
      kind: 'ScalarField',
      alias: null,
      name: 'edgeCount',
      args: null,
      storageKey: null
    },
    v5 = {
      kind: 'ScalarField',
      alias: null,
      name: 'id',
      args: null,
      storageKey: null
    },
    v6 = {
      kind: 'ScalarField',
      alias: null,
      name: 'subject',
      args: null,
      storageKey: null
    },
    v7 = {
      kind: 'ScalarField',
      alias: null,
      name: 'fullName',
      args: null,
      storageKey: null
    },
    v8 = {
      kind: 'ScalarField',
      alias: null,
      name: 'representativeImageUrl',
      args: null,
      storageKey: null
    },
    v9 = {
      kind: 'ScalarField',
      alias: null,
      name: 'name',
      args: null,
      storageKey: null
    },
    v10 = {
      kind: 'ScalarField',
      alias: null,
      name: 'state',
      args: null,
      storageKey: null
    };
  return {
    kind: 'Request',
    fragment: {
      kind: 'Fragment',
      name: 'SolicitationsPageQuery',
      type: 'Query',
      metadata: null,
      argumentDefinitions: (v0 /*: any*/),
      selections: [
        {
          kind: 'LinkedField',
          alias: null,
          name: '__type',
          storageKey: '__type(name:"SolicitationState")',
          args: (v1 /*: any*/),
          concreteType: '__Type',
          plural: false,
          selections: [
            {
              kind: 'FragmentSpread',
              name: 'SolicitationsList_stateTypes',
              args: null
            }
          ]
        },
        {
          kind: 'FragmentSpread',
          name: 'SolicitationsList_solicitations',
          args: null
        },
        {
          kind: 'FragmentSpread',
          name: 'SolicitationQuickView_solicitation',
          args: null
        }
      ]
    },
    operation: {
      kind: 'Operation',
      name: 'SolicitationsPageQuery',
      argumentDefinitions: (v0 /*: any*/),
      selections: [
        {
          kind: 'LinkedField',
          alias: null,
          name: 'allSolicitations',
          storageKey: null,
          args: [
            {
              kind: 'Variable',
              name: 'after',
              variableName: 'after'
            },
            {
              kind: 'Variable',
              name: 'first',
              variableName: 'first'
            },
            {
              kind: 'Variable',
              name: 'includeClosed',
              variableName: 'includeClosed'
            },
            {
              kind: 'Variable',
              name: 'orderBy',
              variableName: 'orderBy'
            },
            {
              kind: 'Variable',
              name: 'replyByFrom',
              variableName: 'replyByFrom'
            },
            {
              kind: 'Variable',
              name: 'replyByTo',
              variableName: 'replyByTo'
            },
            {
              kind: 'Variable',
              name: 'staffCoordinator',
              variableName: 'staffCoordinator'
            },
            {
              kind: 'Variable',
              name: 'state',
              variableName: 'state'
            },
            {
              kind: 'Variable',
              name: 'subject',
              variableName: 'subject'
            }
          ],
          concreteType: 'SolicitationNodeConnection',
          plural: false,
          selections: [
            (v2 /*: any*/),
            (v3 /*: any*/),
            (v4 /*: any*/),
            {
              kind: 'LinkedField',
              alias: null,
              name: 'edges',
              storageKey: null,
              args: null,
              concreteType: 'SolicitationNodeEdge',
              plural: true,
              selections: [
                {
                  kind: 'LinkedField',
                  alias: null,
                  name: 'node',
                  storageKey: null,
                  args: null,
                  concreteType: 'SolicitationNode',
                  plural: false,
                  selections: [
                    (v5 /*: any*/),
                    {
                      kind: 'ScalarField',
                      alias: null,
                      name: 'created',
                      args: null,
                      storageKey: null
                    },
                    (v6 /*: any*/),
                    {
                      kind: 'ScalarField',
                      alias: null,
                      name: 'replyByDate',
                      args: null,
                      storageKey: null
                    },
                    {
                      kind: 'LinkedField',
                      alias: null,
                      name: 'staffCoordinator',
                      storageKey: null,
                      args: null,
                      concreteType: 'StaffNode',
                      plural: false,
                      selections: [
                        (v7 /*: any*/),
                        (v8 /*: any*/),
                        {
                          kind: 'LinkedField',
                          alias: null,
                          name: 'user',
                          storageKey: null,
                          args: null,
                          concreteType: 'UserNode',
                          plural: false,
                          selections: [(v5 /*: any*/)]
                        },
                        (v5 /*: any*/)
                      ]
                    },
                    {
                      kind: 'LinkedField',
                      alias: null,
                      name: 'releases',
                      storageKey: null,
                      args: null,
                      concreteType: 'ReleaseNode',
                      plural: true,
                      selections: [
                        (v9 /*: any*/),
                        (v5 /*: any*/),
                        {
                          kind: 'LinkedField',
                          alias: null,
                          name: 'product',
                          storageKey: null,
                          args: null,
                          concreteType: 'ProductNode',
                          plural: false,
                          selections: [
                            {
                              kind: 'ScalarField',
                              alias: null,
                              name: 'title',
                              args: null,
                              storageKey: null
                            },
                            (v5 /*: any*/)
                          ]
                        }
                      ]
                    },
                    (v10 /*: any*/),
                    {
                      kind: 'ScalarField',
                      alias: null,
                      name: 'numberOfContractors',
                      args: null,
                      storageKey: null
                    },
                    {
                      kind: 'ScalarField',
                      alias: null,
                      name: 'numberOfDeliverables',
                      args: null,
                      storageKey: null
                    },
                    {
                      kind: 'ScalarField',
                      alias: null,
                      name: 'totalDeliverableAmount',
                      args: null,
                      storageKey: null
                    },
                    {
                      kind: 'ScalarField',
                      alias: null,
                      name: 'solicitationId',
                      args: null,
                      storageKey: null
                    },
                    {
                      kind: 'ScalarField',
                      alias: null,
                      name: 'numberOfAllocatedDeliverables',
                      args: null,
                      storageKey: null
                    },
                    {
                      kind: 'ScalarField',
                      alias: null,
                      name: 'numberOfAllocatedContractedDeliverables',
                      args: null,
                      storageKey: null
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          kind: 'LinkedField',
          alias: null,
          name: '__type',
          storageKey: '__type(name:"SolicitationState")',
          args: (v1 /*: any*/),
          concreteType: '__Type',
          plural: false,
          selections: [
            {
              kind: 'LinkedField',
              alias: null,
              name: 'enumValues',
              storageKey: null,
              args: null,
              concreteType: '__EnumValue',
              plural: true,
              selections: [
                (v9 /*: any*/),
                {
                  kind: 'ScalarField',
                  alias: null,
                  name: 'description',
                  args: null,
                  storageKey: null
                }
              ]
            }
          ]
        },
        {
          kind: 'LinkedField',
          alias: null,
          name: 'solicitation',
          storageKey: 'solicitation(id:"")',
          args: [
            {
              kind: 'Literal',
              name: 'id',
              value: ''
            }
          ],
          concreteType: 'SolicitationNode',
          plural: false,
          selections: [
            (v6 /*: any*/),
            {
              kind: 'ScalarField',
              alias: null,
              name: 'message',
              args: null,
              storageKey: null
            },
            (v5 /*: any*/),
            (v10 /*: any*/),
            {
              kind: 'LinkedField',
              alias: null,
              name: 'contractors',
              storageKey: 'contractors(orderBy:"newest_comment")',
              args: [
                {
                  kind: 'Literal',
                  name: 'orderBy',
                  value: 'newest_comment'
                }
              ],
              concreteType: 'ContractorNodeConnection',
              plural: false,
              selections: [
                (v2 /*: any*/),
                (v3 /*: any*/),
                (v4 /*: any*/),
                {
                  kind: 'LinkedField',
                  alias: null,
                  name: 'edges',
                  storageKey: null,
                  args: null,
                  concreteType: 'ContractorNodeEdge',
                  plural: true,
                  selections: [
                    {
                      kind: 'LinkedField',
                      alias: null,
                      name: 'node',
                      storageKey: null,
                      args: null,
                      concreteType: 'ContractorNode',
                      plural: false,
                      selections: [
                        (v5 /*: any*/),
                        (v7 /*: any*/),
                        (v8 /*: any*/),
                        {
                          kind: 'ScalarField',
                          alias: null,
                          name: 'numberOfCommentsInSolicitation',
                          args: null,
                          storageKey: null
                        },
                        {
                          kind: 'LinkedField',
                          alias: null,
                          name: 'freelancer',
                          storageKey: null,
                          args: null,
                          concreteType: 'FreelancerNode',
                          plural: false,
                          selections: [
                            {
                              kind: 'LinkedField',
                              alias: null,
                              name: 'user',
                              storageKey: null,
                              args: null,
                              concreteType: 'UserNode',
                              plural: false,
                              selections: [
                                {
                                  kind: 'ScalarField',
                                  alias: null,
                                  name: 'userId',
                                  args: null,
                                  storageKey: null
                                },
                                (v5 /*: any*/)
                              ]
                            },
                            (v5 /*: any*/)
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    params: {
      operationKind: 'query',
      name: 'SolicitationsPageQuery',
      id: null,
      text:
        'query SolicitationsPageQuery(\n  $first: Int\n  $orderBy: String\n  $after: String\n  $replyByFrom: Date\n  $replyByTo: Date\n  $state: String\n  $subject: String\n  $staffCoordinator: ID\n  $includeClosed: Boolean\n) {\n  ...SolicitationsList_solicitations\n  __type(name: "SolicitationState") {\n    ...SolicitationsList_stateTypes\n  }\n  ...SolicitationQuickView_solicitation\n}\n\nfragment SolicitationsList_solicitations on Query {\n  allSolicitations(first: $first, orderBy: $orderBy, after: $after, replyByFrom: $replyByFrom, replyByTo: $replyByTo, state: $state, subject: $subject, staffCoordinator: $staffCoordinator, includeClosed: $includeClosed) {\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    totalCount\n    edgeCount\n    edges {\n      node {\n        id\n        created\n        subject\n        replyByDate\n        staffCoordinator {\n          fullName\n          representativeImageUrl\n          user {\n            id\n          }\n          id\n        }\n        releases {\n          name\n          id\n          product {\n            title\n            id\n          }\n        }\n        state\n        numberOfContractors\n        numberOfDeliverables\n        totalDeliverableAmount\n        solicitationId\n        numberOfAllocatedDeliverables\n        numberOfAllocatedContractedDeliverables\n      }\n    }\n  }\n}\n\nfragment SolicitationsList_stateTypes on __Type {\n  enumValues {\n    name\n    description\n  }\n}\n\nfragment SolicitationQuickView_solicitation on Query {\n  solicitation(id: "") {\n    subject\n    message\n    ...SolicitationQuickViewContractorList_solicitation\n    id\n  }\n}\n\nfragment SolicitationQuickViewContractorList_solicitation on SolicitationNode {\n  id\n  state\n  contractors(orderBy: "newest_comment") {\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    totalCount\n    edgeCount\n    edges {\n      node {\n        id\n        fullName\n        representativeImageUrl\n        numberOfCommentsInSolicitation\n        freelancer {\n          user {\n            userId\n            id\n          }\n          id\n        }\n      }\n    }\n  }\n}\n',
      metadata: {}
    }
  };
})();
// prettier-ignore
(node/*: any*/).hash = 'f9ed312aa4ad6e465e22218b165361f2';
module.exports = node;
